import { Badge } from "../../primitives/Badge";
import { ProcessTemplateActions } from "./ProcessTemplateActions";
import type { ProcessTemplate } from "../../../api/processes";

type ProcessConfigurationHeaderProps = {
  template: ProcessTemplate & {
    current_version?: {
      id: string;
      version_number: number;
      published_at: string | null;
      state?: string;
    };
  };
  onUpdate: () => void;
  onTemplateDeleted?: () => void;
};

export function ProcessConfigurationHeader({ template, onUpdate, onTemplateDeleted }: ProcessConfigurationHeaderProps) {
  const getStatusBadge = () => {
    if (template.status === "archived") {
      return { label: "Archivé", tone: "neutral" as const };
    }
    const hasPublished = template.current_version?.published_at !== null;
    if (hasPublished) {
      return { label: "Publié", tone: "success" as const };
    }
    return { label: "Brouillon", tone: "warning" as const };
  };

  const getVersionLabel = () => {
    if (!template.current_version) {
      return "Aucune version";
    }
    const version = template.current_version;
    const versionNum = version.version_number || 1;
    const state = version.published_at ? "Published" : "Draft";
    return `v${versionNum} (${state})`;
  };

  const statusBadge = getStatusBadge();

  return (
    <div className="border-b border-border bg-surface p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h2 className="text-lg font-semibold">{template.name}</h2>
            <Badge label={statusBadge.label} tone={statusBadge.tone} />
          </div>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            {template.current_version && (
              <span className="font-medium">Version: {getVersionLabel()}</span>
            )}
            {template.ops_family && (
              <span>Famille d'opération: <span className="font-medium">{template.ops_family}</span></span>
            )}
          </div>
        </div>
        <ProcessTemplateActions template={template} onUpdate={onUpdate} onTemplateDeleted={onTemplateDeleted} />
      </div>
    </div>
  );
}
